import Helper from "./helper";
import CourseMutation from "./mutations/course";
import StructureMutation from "./mutations/structure";
import MiniGame from "./mutations/minigame";
import Challenge from "./mutations/challenge";
import ToyMutation from "./mutations/toy";
import FieldSetMutation from "./mutations/fieldSet";
import CardTemplateMutation from "./mutations/cardTemplate";
import CardListMutation from "./mutations/cardList";
import CardMutation from "./mutations/card";
import LkMutation from "./mutations/lk";
import PayMutation from "./mutations/pay";
import MappMutation from "./mutations/mapp";
import TournamentMutation from "./mutations/tournament";
import AiMutation from "./mutations/ai";

export default class Api 
{
    static course = new CourseMutation(); 
    static structure = new StructureMutation(); 
    static miniGame = new MiniGame();
    static challenge = new Challenge();
    static toy = new ToyMutation();
    static fieldSet = new FieldSetMutation();
    static cardTemplate = new CardTemplateMutation();
    static cardList = new CardListMutation();
    static card = new CardMutation();
    static lk = new LkMutation();
    static pay = new PayMutation();
    static mapp = new MappMutation();
    static tournament = new TournamentMutation();
    static ai = new AiMutation();

    static delay(millis) {
        return new Promise(resolve => {
            setTimeout(()=>resolve(), millis);
        });
    }

    static async postData(url = '', data = {}) {
        try {
            const response = await fetch(url, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                headers: { 
                    'Content-Type': 'application/json',
                    'TimeZoneOffset': -new Date().getTimezoneOffset(),
                },
                body: JSON.stringify(data)
            });
            let text = await response.text();
            if (!response.ok) {
                if (response.status == 401) {
                    Api.showError('You do not have permission to perform this action');
                } else {
                    console.error("Failed to fetch", url, data, response);
                    Api.showError('Failed to process request<br/> Please refresh the page and try once more');
                }
            }
            try {
                let obj = text.startsWith("{") || text.startsWith("[") ? JSON.parse(text) : text;
                console.log("POST", url, 'request', data, 'response', obj);
                
                if (obj.errors && obj.errors.length) {
                    console.error("GraphQl call error: ", obj.errors[0]);
                }
                return obj;
            } catch (e) {
                console.error("failed to decode <" + text + ">");
                Api.showError('Internal Server Error<br/>We already investigate the issue');
                return text;
            }
        } catch (ex) {
            console.error("Failed to execute request to", url, data, ex);
            Api.showError('Internal Server Error<br/>We already investigate the issue');
            return { ok: false };
        }
    }

    static async saveImage(file, thumbnails) {
        try {
            const formData = new FormData();
            formData.append('file', file);
            if (thumbnails) {
                formData.append('thumbnails', JSON.stringify(thumbnails));
            }

            const response = await fetch('/api/saveImage', {
                method: 'POST',
                body: formData,
            });
            let text = await response.text();
            if (!response.ok) {
                if (response.status == 401) {
                    Api.showError('You do not have permission to perform this action');
                } else {
                    console.error("Failed to save image", response);
                    Api.showError('Failed to save image');
                }
            }
            try {
                let obj = JSON.parse(text);
                console.log("response", obj);
                return obj;
            } catch (e) {
                console.error("failed to decode <" + text + ">");
                Api.showError('Failed to save image');
                return text;
            }
        } catch (ex) {
            console.error("Failed to execute request to", ex);
            Api.showError('Internal Server Error');
            return { ok: false };
        }
    }

    static async saveFile(file) {
        try {
            const formData = new FormData();
            formData.append('file', file);

            const response = await fetch('/api/saveFile', {
                method: 'POST',
                body: formData,
            });
            let text = await response.text();
            if (!response.ok) {
                if (response.status == 401) {
                    Api.showError('You do not have permission to perform this action');
                } else {
                    console.error("Failed to save file", response);
                    Api.showError('Failed to save file');
                }
            }
            try {
                let obj = JSON.parse(text);
                console.log("response", obj);
                return obj;
            } catch (e) {
                console.error("failed to decode <" + text + ">");
                Api.showError('Failed to save file');
                return text;
            }
        } catch (ex) {
            console.error("Failed to execute request to", ex);
            Api.showError('Internal Server Error');
            return { ok: false };
        }
    }

    static async postString(url = '', str) {
        try {
            const response = await fetch(url, {
                method: 'POST', // *GET, POST, PUT, DELETE, etc.
                headers: { 'Content-Type': 'application/json' },
                body: str
            });
            let text = await response.text();
            if (!response.ok) {
                if (response.status == 401) {
                    Api.showError('You do not have permission to perform this action');
                } else {
                    console.error("Failed to fetch", url, data, response);
                    Api.showError('Failed to process request<br/> Please refresh the page and try once more');
                }
            }
            try {
                let obj = JSON.parse(text);
                console.log("response", obj);
                return obj;
            } catch (e) {
                console.error("failed to decode <" + text + ">");
                Api.showError('Internal Server Error<br/>We already investigating the issue');
                return text;
            }
        } catch (ex) {
            console.error("Failed to execute request to", url, data);
            Api.showError('Internal Server Error<br/>We already investigating the issue');
            return { ok: false };
        }
    }

    static showError(errorMessage) {
        if (!window.Toastify) return
        Toastify({
            text: errorMessage,
            duration: 3000,
            newWindow: true,
            close: true,
            gravity: "top",
            position: 'right',
            backgroundColor: "linear-gradient(to right, rgb(176, 0, 146), rgb(97, 10, 103))",
            stopOnFocus: true,
        }).showToast();
    }

    static showWarning(errorMessage) {
        if (!window.Toastify) return
        Toastify({
            text: errorMessage,
            duration: 3000,
            newWindow: true,
            close: true,
            gravity: "top",
            position: 'center',
            backgroundColor: "linear-gradient(to right, rgb(222 144 0), rgb(255 118 0))",
            stopOnFocus: true,
        }).showToast();
    }

    static showSuccess(message) {
        if (!window.Toastify) return
        Toastify({
            text: message,
            duration: 3000,
            newWindow: true,
            close: true,
            gravity: "top",
            position: 'center',
            backgroundColor: "linear-gradient(to right, #07bc0c, #07ac0c)",
            stopOnFocus: true,
        }).showToast();
    }

    static convertNodeToSkill(link, node, graphId) {
        return {
            skill: {
                id: node.id,
                name: node.name,
                description: node.description,
            },
            graphId: graphId,
            link: {
                parentId: link.source,
                skillId: link.target,
                graphId: graphId,
                data: link.params ? JSON.stringify(link.params) : "",
            }
        };
    }

    static async loadTags(skill) {
        let result = await Api.postData('/api/loadTags', skill.id);
        return result;
    }

    static async loadSkillsetStats(id) {
        let result = await Api.postData('/api/skillsetStats?id=' + id);
        return result;
    }

    static async setTimezone() {
        let result = await Api.postData('/api/timezone');
        return result;
    }

    static async setDefinition(leafLinkId, definition) {
        return await Api.postData('/api/setDefinition', { leafLinkId: leafLinkId, definition: definition });
    }
        
    static async addSkill( node, graphId, subject) {
        let request = Api.convertNodeToSkill({}, node, graphId);
        request.params = node.params;
        request.subjectId = subject ? subject.id : null;
        let result = await Api.postData('/api/add', request);
        return result;
    }

    static async saveUserSkill(skillId, knows, level, userId) {
        let result = await Api.postData('/api/saveUserSkill', { skillId: skillId, knows: knows, userId: userId, level: +level });
        return result;
    }


    static async saveCourse(course) {
        let request = {
            id: course.id,
            name: course.name || "",
            description: course.description || "",
            author: course.author || "",
            imageUrl: course.imageUrl || "",
            lessons: [...course.lessons.filter(l => !l.dummy).map(lesson => {
                return {
                    id: lesson.id,
                    name: lesson.name || "",
                    description: lesson.description || "",
                    section: lesson.section || "",
                    materials: [...lesson.materials.filter(l => !l.dummy).map(material => {
                        return {
                            id: material.id,
                            name: material.name || "",
                            description: material.description || "",
                            url: material.url || "",
                            materialType: material.materialType || "",
                            prerequisiteIds: [...material.prerequisites.map(c => c.id)],
                            skillIds: [...material.skills.map(c => c.id)],
                        };
                    })],
                };
            })],
        };
        console.log("Saving course", request);

        let result = await Api.postData('/api/saveCourse', request);
        return result;
    }

    static async saveArticle(article, prerequisites, skills) {
        let request = {
            id: article.id,
            title: article.title || "",
            text: article.text || "",            
            imageUrl: article.imageUrl || "",
            prerequisites: prerequisites.map(c => c.id),
            skillIds: skills.map(c => c.id),
        };
        console.log("Saving article", request);

        let result = await Api.postData('/api/saveArticle', request);
        return result;
    }

    static async event(targetId, targetName, name, type, data) {
        const eventData = { targetId: targetId, targetName: targetName, type: type, name: name, data: data };
        const blob = new Blob([JSON.stringify(eventData)], { type: 'application/json; charset=UTF-8' });
        navigator.sendBeacon('/api/event', blob);
    }

    static async finishApplyVacancy(vacancyId, userId, startTimestamp, endTimestamp, channel = "") {
        let result = await Api.postData('/api/finishApplyVacancy', { 
            VacancyId: vacancyId,
            UserId: userId,
            StartTimestamp: startTimestamp,
            EndTimestamp: endTimestamp,
            SlackChannelOverwrite: channel
        });

        return result;
    }

    static async feedback(text, email, rate) {
        let result = await Api.postData('/api/feedback', { text: text, email: email, rate: rate, url: location.href });
        return result;
    }

    static async addSkillMaterial(data) {
        let result = await Api.postData('/api/addSkillMaterial', data);
        return result;
    }

    static async setUserSubject(subject_id, user_id, knows) {
        let result = await Api.postData('/api/setUserSubject', {subjectId: subject_id, userId: user_id, knows: knows});
        return result;
    }

    static async addSkillQuestion(data) {
        let result = await Api.postData('/api/addSkillQuestion', data);
        return result;
    }

    static async addSkillKnowledge(data) {
        let result = await Api.postData('/api/addSkillKnowledge', data);
        return result;
    }

    static async saveLinkOrder(linkIds) {
        let result = await Api.postData('/api/saveLinkOrder', { linkIds: linkIds });
        return result;
    }

    static async addSkillExpertise(data) {
        let result = await Api.postData('/api/addSkillExpertise', data);
        return result;
    }

    static async saveUserProject(project) {
        let query = `mutation ($project: ProjectInput!) {
          saveProject(project: $project) 
        }`;
        let toNullableInt = d => (+d) != 0 || d === "0" ? (+d) : null;
        return await Api.postData('/g', {
            query: query, variables: {
                project: {
                        id: project.id,
                        name: project.name,
                        description: project.description,
                        company: project.company,
                        startYear: toNullableInt(project.startYear),
                        endYear: toNullableInt(project.endYear),
                        scale: project.scale,
                        role: project.role,
                        achievements: project.achievements,
                        skills: project.skills.map(s=>s.id),
                    },
            }
        });
    }

    static async skillsInSubject(subjectId) {
        let query = `query {
          skillsInSubject(subjectId: "${subjectId}") {
            id,name,description,type,knows(userId: "${userId}") }
          }
        }`;
        let result = await Api.postData('/g', { query: query });
        let skills = result.data.skillsInSubject;
        return skills;
    }

    static async subjectsCatalogTop(subjectId) {
        let query = `query ($subjectId: String!) {
            primarySubjectsLevels(id: $subjectId) {
              id, name, topSubjectId, imageUrl
            }  
            graph(id:"SubjectsCatalog") {
              id, name,
              topNodes {
                id, name, imageUrl
              }
            }
          }`
        return await Api.postData('/g', { query: query, variables: {
            subjectId: subjectId || ""
        } });
    }

    static async getSkillDescription(skillId) {
        let query = `query {
          skill(id: "${skillId}") {
            description
          }
        }`;
        let result = await Api.postData('/g', { query: query });
        return result.data.skill?.description;
    }

    static async getSkillInfo(skillId) {
        let query = `query {
          skill(id: "${skillId}") {
            id, name, primarySubject {id, name}
          }
        }`;
        let result = await Api.postData('/g', { query: query });
        return result.data.skill;
    }
    
    static async spaceExpertise(skillId) {
        let query = `query {
            subject(id:"${skillId}") {
                expertises {
                    id, name,
                    links {
                        id, source:skillId, target:parentId, data
                    },
                    topNodes {
                        id, source:skillId, target:parentId, data
                    },
                    nodes {
                        id, name, 
                    }
                }
            }
        }`;
        let result = await Api.postData('/g', { query: query });
        if (!result.data.subject) return [];
        let expertises = result.data.subject.expertises;
        return expertises;
    }

    static async searchInSubject(type, subjectId, text) {
        let query = `query ($text: String!) {
          searchInSubject(type: "${type}", subjectId: "${subjectId}", text: $text) {
            ... on Node {
              id,name,description,type
            }
            ... on Skill {
              area,primarySubject { name }
            }
          }
        }`;
        let result = await Api.postData('/g', { query: query, variables: { text: text }  });
        let skills = result.data.searchInSubject;
        return skills;
    }

    static async vacancyQuizzes(vacancyId) {
        let query = `query ($vacancyId: String!) {
          vacancy(id: $vacancyId) {
              quizzes {
                  id, name, 
                  questions {
                      id, question, score, required,
                      skill: firstSkill { id, name }
                  }
              },
              question_bank {
                  id, question,
                  skill: firstSkill { id, name }
            }
          }
        }`;
        return await Api.postData('/g', { query: query, variables: { vacancyId: vacancyId }  });
    }

    static async linkExpertise(nodeId, expertiseId, link) {
        let query = `mutation {
          linkExpertise(nodeId: "${nodeId}", expertiseId: "${expertiseId}", link: ${link ? 'true' : 'false'}) 
        }`;
        await Api.postData('/g', { query: query });
    }

    static async studySkill(skillId, study) {
        let query = `mutation($id: String!, $study: Boolean!) {
          studySkill(id: $id, study: $study)
        }`;
        return await Api.postData('/g', { query: query, variables: {id: skillId, study: study} });
    }

    static async answerSkill(skillId, quality) {
        let query = `mutation($skillId: String!, $quality: Int!) {
          answerSkill(skillId: $skillId, quality: $quality) {
            remindAt
          }
        }`;
        return await Api.postData('/g', { query: query, variables: {skillId: skillId, quality: quality} });
    }
    
    static async applyVacancy(vacancyId) {
        let query = `mutation {
          applyVacancy(vacancyId: "${vacancyId}")  {
              code, vacancyApplicationId, vacancyId
          }
        }`;
        return await Api.postData('/g', { query: query });
    }

    static async createVacancyApplicationLink(vacancyId, name, phone, email) {
        let query = `mutation ($vacancyId: String!, $name: String!, $phone: String!, $email: String) {
          createVacancyApplicationLink(vacancyId: $vacancyId, name: $name, phone: $phone, email: $email)  {
              code, vacancyApplicationId, vacancyId, hyperlink
          }
        }`;
        return await Api.postData('/g', { query: query, variables: {name: name, phone: phone, email: email, vacancyId: vacancyId} });
    }

    static async answerVacancyQuizz(vacancyApplicationId, questionId, answers, files) {
        let query = `mutation ($answers: [String!]!, $files: [String!]!) {
          answerVacancyQuizz(vacancyApplicationId: "${vacancyApplicationId}", questionId: "${questionId}", answers: $answers, files: $files)
        }`;
        return await Api.postData('/g', { query: query, variables: { answers: answers, files: files || [] } });
    }

    static async verifyVacancyQuizz(userSkillId, correct, score) {
        let query = `mutation($score: Int!) {
          verifyVacancyQuizz(userSkillId: "${userSkillId}", correct: ${correct}, score: $score)
        }`;
        return await Api.postData('/g', { query: query, variables: { score: +score || 1} });
    }

    static async startVacancyApplicationQuizz(vacancyApplicationId, questionId, answers) {
        let query = `mutation() {
          startVacancyApplicationQuizz(vacancyApplicationId: "${vacancyApplicationId}")
        }`;
        return await Api.postData('/g', { query: query, variables: { answers: answers } });
    }

    static async finishVacancyApplicationQuizz(vacancyApplicationId, questionId, answers) {
        let query = `mutation {
          finishVacancyApplicationQuizz(vacancyApplicationId: "${vacancyApplicationId}")
        }`;
        return await Api.postData('/g', { query: query, variables: { answers: answers } });
    }

    static async getNewSkills(userIds, skillsetIds, period) {
        let query = `query ($userIds: [String!]!, $skillsetIds: [String!]!, $period: TimeSpan!) {
          newSkills(userIds: $userIds, skillsets: $skillsetIds, period: $period) {
             user { id },
             skillset { id },
             newSkills { id, name },
             newEndorsements {
                endorser { id, visualName}, 
                evidence { name, url, description }, 
                userSkill { 
                    skill { 
                        id, name
                    }
                } 
             }
          }
        }`;
        return await Api.postData('/g', { query: query, variables: { userIds: userIds, skillsetIds: skillsetIds, period: period } });
    }

    static async addUserGradeExpert(userGradeId, userId) {
        let query = `mutation ($userGradeId: String!, $userId: String!) {
            addUserGradeExpert(userGradeId: $userGradeId, userId: $userId)
        }`;
        return await Api.postData('/g', { query: query, variables: { userGradeId: userGradeId, userId: userId} });
    }

    static async removeUserGradeExpert(userGradeId, userId) {
        let query = `mutation ($userGradeId: String!, $userId: String!) {
            removeUserGradeExpert(userGradeId: $userGradeId, userId: $userId)
        }`;
        return await Api.postData('/g', { query: query, variables: { userGradeId: userGradeId, userId: userId } });
    }

    static async addGradeSkillset(gradeId, skillsetId) {
        let query = `mutation ($gradeId: String!, $skillsetId: String!) {
          addGradeSkillset(gradeId: $gradeId, skillsetId: $skillsetId)
        }`;
        return await Api.postData('/g', { query: query, variables: { gradeId: gradeId, skillsetId: skillsetId} });
    }

    static async removeGradeSkillset(gradeId, skillsetId) {
        let query = `mutation ($gradeId: String!, $skillsetId: String!) {
          removeGradeSkillset(gradeId: $gradeId, skillsetId: $skillsetId)
        }`;
        return await Api.postData('/g', { query: query, variables: { gradeId: gradeId, skillsetId: skillsetId } });
    }

    static async removeRoleGrade(roleId, gradeId) {
        let query = `mutation ($roleId: String!, $gradeId: String!) {
          removeRoleGrade(roleId: $roleId, gradeId: $gradeId)
        }`;
        return await Api.postData('/g', { query: query, variables: { roleId: roleId, gradeId: gradeId } });
    }

    static async removeOrganizationRole(organizationId, roleId) {
        let query = `mutation ($organizationId: String!, $roleId: String!) {
          removeOrganizationRole(organizationId: $organizationId, roleId: $roleId)
        }`;
        return await Api.postData('/g', { query: query, variables: { organizationId: organizationId, roleId: roleId } });
    }
    
    static async createTeam(id, name, organizationId) {
        return await Api.postData('/api/createTeam', { id: id, name: name, organizationId: organizationId});
    }

    static async removeOrganizationTeam(organizationId, teamId) {
        let query = `mutation ($organizationId: String!, $teamId: String!) {
          removeOrganizationTeam(organizationId: $organizationId, teamId: $teamId)
        }`;
        return await Api.postData('/g', { query: query, variables: { organizationId: organizationId, teamId: teamId } });
    }

    static async createRole(id, name, organizationId) {
        return await Api.postData('/api/createRole', { id: id, name: name, organizationId: organizationId });
    }

    static async renameGrade(id, name) {
        return await Api.postData('/api/renameGrade', { id: id, name: name });
    }

    static async createGrade(id, name, roleId) {
        return await Api.postData('/api/createGrade', { id: id, name: name, roleId: roleId });
    }

    static async addTeamMember(teamId, userId) {
        let query = `mutation ($teamId: String!, $userId: String!) {
          addTeamMember(teamId: $teamId, userId: $userId)
        }`;
        return await Api.postData('/g', { query: query, variables: { teamId: teamId, userId: userId } });
    }

    static async removeTeamMember(teamId, userId) {
        let query = `mutation ($teamId: String!, $userId: String!) {
          removeTeamMember(teamId: $teamId, userId: $userId)
        }`;
        return await Api.postData('/g', { query: query, variables: { teamId: teamId, userId: userId } });
    }

    static async addGradeMember(gradeId, userId) {
        let query = `mutation ($gradeId: String!, $userId: String!) {
          addGradeMember(gradeId: $gradeId, userId: $userId)
        }`;
        return await Api.postData('/g', { query: query, variables: { gradeId: gradeId, userId: userId } });
    }

    static async removeGradeMember(gradeId, userId) {
        let query = `mutation ($gradeId: String!, $userId: String!) {
          removeGradeMember(gradeId: $gradeId, userId: $userId)
        }`;
        return await Api.postData('/g', { query: query, variables: { gradeId: gradeId, userId: userId } });
    }

    static async claimAchievement(parentId, achievementId) {
        let query = `mutation ($parentId: String!, $achievementId: String!) {
          claimAchievement(parentId: $parentId, achievementId: $achievementId)
        }`;
        return await Api.postData('/g', { query: query, variables: { parentId: parentId, achievementId: achievementId } });
    }
    
    static async searchSkillsInSubject(subjectId, text) {
        let query = `{
          searchSkillsInSubject(subjectId: "${subjectId}", text: "${text}") {
            id,name
          }
        }`;
        let result = await Api.postData('/g', { query: query });
        let skills = result.data.searchSkillsInSubject;
        return skills;
    }

    static async searchProfessions(text) {
        let query = `{
          searchProfessions(text: "${text}") {
            id,name
          }
        }`;
        let result = await Api.postData('/g', { query: query });
        let skills = result.data.searchProfessions;
        return skills;
    }

    static async searchUsers(text) {
        let query = `{
          searchUsers(text: "${text}") {
            id,visualName
          }
        }`;
        let result = await Api.postData('/g', { query: query });
        let skills = result.data.searchUsers;
        return skills;
    }

    static async searchSkillsets(text) {
        let query = `query ($text: String!) {
          searchSkillsets(text: $text) {
            id,name,authorName,primarySubject{id,name}
          }
        }`;
        let result = await Api.postData('/g', { query: query, variables: { text: text } });
        return result.data.searchSkillsets;
    }
            
    static async removeSkill(node, graphId) {
        console.log("removing skill", graphId, node);
        let result = await Api.postData('/api/remove', Api.convertNodeToSkill({}, node, graphId));
        return result;
    }

    static async removeLink(source_id, target_id, graphId) {
        console.log("removing link", graphId, source_id, '->', target_id);
        let result = await Api.postData('/api/removeLink', { graphId: graphId, sourceId: source_id, targetId: target_id });
        return result;
    }

    static async publishCourse(courseId, published) {
        let result = await Api.postData('/api/publishCourse', { courseId: courseId, published: published });
        return result;
    }

    static async publishArticle(articleId, published) {
        let result = await Api.postData('/api/publishArticle', { articleId: articleId, published: published });
        return result;
    }

    static async publishSkillset(skillsetId, published) {
        let query = `mutation ($skillsetId: String!, $published: Boolean!) {
          publishSkillset(skillsetId: $skillsetId, published: $published)
        }`;
        return await Api.postData('/g', { query: query, variables: { published: published, skillsetId: skillsetId } });
    }

    static async saveVacancyQuizz(vacancyId, quizzId, quizzName, questionIds, scores, required) {
        let query = `mutation ($vacancyId: String!, $quizzId: String!, $name: String!, $questionIds: [String!]!, $scores: [Int!]!, $required: [Boolean!]!) {
            saveVacancyQuizz(vacancyId: $vacancyId, quizzId: $quizzId, name: $name, questionIds: $questionIds, scores: $scores, required: $required)
        }`;
        return await Api.postData('/g', { query: query, variables: { 
            vacancyId: vacancyId, 
            quizzId: quizzId,
            name: quizzName,
            questionIds: questionIds,
            scores: scores,
            required: required,
        } });
    }

    static async catalog(subjectId, language) {
        return await Api.postData('/api/catalog?subjectId=' + subjectId + "&lang=" + language);
    }

    static async catalogLevel(subjectId, language) {
        return await Api.postData('/api/catalog-level?subjectId=' + subjectId + "&lang=" + language);
    }

    static async removeCourse(courseId) {
        let result = await Api.postData('/api/removeCourse', { courseId: courseId });
        return result;
    }

    static async removeArticle(articleId) {
        let result = await Api.postData('/api/removeArticle', { articleId: articleId });
        return result;
    }

    static async addUserCatalogLink(source_id, target_id, userId, catalogId, linkId) {
        console.log("adding user catalog link", userId, source_id, '->', target_id);
        let result = await Api.postData('/api/addUserCatalogLink', { userId: userId, sourceId: source_id, targetId: target_id, catalogId: catalogId, linkId: linkId });
        return result;
    }

    static async removeUserCatalogLink(linkId) {
        console.log("removing user catalog link", linkId);
        let result = await Api.postData('/api/removeUserCatalogLink', { linkId: linkId });
        return result;
    }
    
    static async searchSubjects(q) {
        let response = await fetch('/api/searchSubjects?q=' + encodeURIComponent(q));
        let result = await response.json();
        return result;
    }

    static async loadSkillSubjects(skillId, graphId) {
        let result = await Api.postData('/api/loadSkillSubjects', { skillId: skillId, graphId: graphId });
        return result;
    }

    static async getGraph(graphId) {
        let result = await Api.postData('/api/getGraph', { graphId: graphId });
        return result;
    }

    static async getUserSubjects(graphId, userId) {
        let result = await Api.postData('/api/getUserSubjects', { graphId: graphId, userId });
        return result;
    }

    static async saveGraph(graphId, topNodes, nodes, links) {
        let result = await Api.postData('/api/saveGraph', { graphId: graphId, topNodes: topNodes, nodes: nodes, links: links });
        return result;
    }

    static async saveSkillset(skillset) {
        let result = await Api.postData('/api/saveSkillset', skillset);
        return result;
    }

    static async createDraftMergeRequest(data) {
        let result = await Api.postData('/api/createDraftMergeRequest', data);
        return result;
    }

    static async discardDraftGraph(data) {
        let result = await Api.postData('/api/discardDraftGraph', data);
        return result;
    }

    static async mergeGraphDraft(data) {
        let result = await Api.postData('/api/mergeGraphDraft', data);
        return result;
    }

    static async loadQuestions(skillId) {
        let result = await Api.postData('/api/loadQuestions', { skillId: skillId });
        if (result.ok) {
            let questions = result.data.questions;
            let knowledges = result.data.knowledges;
            let likes = result.data.likes;
            let links = result.data.links;
            for (let i = 0; i < questions.length; ++i) {
                questions[i].link = links[questions[i].id] || {};
                questions[i].canLike = likes[questions[i].id];
                Helper.prepareQuestionAnswers(questions[i]);
            }
            console.log('questions', questions);
            for (let i = 0; i < knowledges.length; ++i) {
                knowledges[i].link = links[knowledges[i].id] || {};
                knowledges[i].canLike = likes[knowledges[i].id];
            }
            console.log('knowledges', knowledges);
        } else {
            console.warn("Failed to load questions", result.error);
        }
        return result;
    }

    static async loadMaterials(skillId, graphId) {
        let result = await Api.postData('/api/loadMaterials', { skillId: skillId, graphId: graphId });
        let materials = result.materials;
        let likes = result.likes;
        let links = result.links;
        for (let i = 0; i < materials.length; ++i) {
            materials[i].link = links[materials[i].id] || {};
            materials[i].canLike = likes[materials[i].id];
        }
        console.log('materials', materials);
        return result;
    }

    static async loadExpertises(skillId) {
        let result = await Api.postData('/api/loadExpertises', { skillId: skillId });
        let expertises = result.data.expertises;
        let authors = result.data.authors;
        for (let i = 0; i < expertises.length; ++i)
            expertises[i].author = authors[expertises[i].authorId];
        return expertises;
    }

    static async loadExpertiseParents(graphId, skillId, userId) {
        let query = `{
          expertiseParentSkills(graphId: "${graphId}", skillId: "${skillId}", userId: "${userId}") {
            skill { id, name, knows(userId: "${userId}") }, isLeaf, userStats, total
          }
        }`;
        let result = await Api.postData('/g', { query: query });
        let items = result.data.expertiseParentSkills;
        return items.map(c => {
            c.skill.leaf = c.count == 0;
            c.skill.userStats = c.userStats;
            c.skill.total = c.total;
            return c.skill;
        });
    }

    static async skillsInSubject(subjectId, userId) {
        let query = `{
          skillsInSubject(subjectId: "${subjectId}") {
            id, name, knows(userId: "${userId}")
          }
        }`;
        let result = await Api.postData('/g', { query: query });
        let items = result.data.skillsInSubject;
        return items;
    }

    static async subjectExpertises(subjectId, userId) {
        let query = `query {
            subjectExpertises(subjectId: "${subjectId}", userId: "${userId}") {
                id, name, imageUrl, description, total, primarySubject {id,name},
                userStats(userId: "${userId}")
            }
        }`;
        let result = await Api.postData('/g', { query: query });
        let items = result.data.subjectExpertises;
        return items;
    }

    static async skillsById(skillIds, userId) {
        let query = `query($skillIds: [String!]!, $userId: String!){
          skillsById(skillIds: $skillIds) {
            id, name, knows(userId: $userId)
          }
        }`;
        let result = await Api.postData('/g', { query: query, variables: {skillIds: skillIds, userId: userId} });
        let items = result.data.skillsById;
        return items;
    }

    static async skillsByIdUserIds(skillIds, userIds) {
        let query = `query($skillIds: [String!]!, $userIds: [String!]!){
          skillsById(skillIds: $skillIds) {
            id, name, knowsMany(userIds: $userIds)
          }
        }`;
        let result = await Api.postData('/g', { query: query, variables: {skillIds: skillIds, userIds: userIds} });
        let items = result.data.skillsById;
        return items;
    }

    static async loadSkillCounts(subjectId, userId) {
        let query = `{
          loadSkillCounts(subjectId: "${subjectId}", userId: "${userId}") {
            totalSkills, userSkills
          }
        }`;
        let result = await Api.postData('/g', { query: query });
        let items = result.data.loadSkillCounts;
        return items;
    }

    static async loadVacancyApplicantsResults(vacancyId)
    {
        let query = `query ($vacancyId: String!) {
            vacancy: node(id: $vacancyId) {
                id, name,
                ... on Vacancy {
                    applications {
                        id, status, timestamp, hyperlink, hrComment
                        user {
                            id, visualName, email
                        }
                        quizz {
                            id,total_count,correct_count,confidence,
                            duration,
                            questions {
                                id, question, correctAnswers, score,
                                allowCustomAnswer, allowFileAnswer,
                                userAnswer: userAnswer2 {
                                    id, correct: completed, answers, verified, score,
                                    files { name, url }
                                },
                                firstSkill {id, name},
                            }
                        }
                    },
                    expertises {
                        vacancyRequiredLevel,
                        expertise {
                            id, name,
                            links {
                                id, skillId, parentId, data
                            },
                            topNodes {
                                id, skillId, parentId
                            },
                            nodes {
                                id, name, linkId, data
                            }
                        }
                    }
                }
            }
        }`;
        return await Api.postData('/g', { query: query, variables: { vacancyId: vacancyId }  });
    }

    static async saveVacancyApplicationHrComment(vacancyApplicationId, comment) {
        let query = `mutation ($vacancyApplicationId: String!, $comment: String!) {
            saveVacancyApplicationHrComment(vacancyApplicationId: $vacancyApplicationId, comment: $comment)
          }`;
          return await Api.postData('/g', { query: query, variables: { vacancyApplicationId: vacancyApplicationId, comment: comment } });
      }

    static async loadSkillQuestions(skillIds) {
        if (skillIds.length == 0)
            return {};

        let query = `{`;

        for (let i = 0; i < skillIds.length; ++i) {
            let skillId = skillIds[i];
            query += `skill_${skillId}: skill(id: "${skillId}") {
                id, questions {
                   id, question, answers, multi, allowCustomAnswer, allowFileAnswer, explanation, imageUrl, score, required
                }
            }`;
        }

        query += `}`;

        let result = await Api.postData('/g', { query: query });
        let questions = {};
        for (let i in result.data) {
            let skill = result.data[i];
            if (!skill) continue;
            for (let i = 0; i < skill.questions.length; ++i) {
                let question = skill.questions[i];
                question.answers = question.answers.map(text => { return { text: text, selected: false }; });
            }
            questions[skill.id] = skill.questions;
        }
        return questions;
    }

    static async vacancyQuestions(vacancyId) {
        let query = `query ($vacancyId: String!) {
          vacancy(id: $vacancyId) {
              quizzes {
                  id, name, 
                  questions {
                      id, question, answers, multi, allowCustomAnswer, allowFileAnswer, answerType, explanation, imageUrl, score, required, childSortIndex,
                      skill: firstSkill{ id }
                  }
              }
          }
        }`;
        return await Api.postData('/g', { query: query, variables: { vacancyId: vacancyId }  });
    }

    static async loadSkillsetRating(skillsetId) {
        let query = `query ($skillsetId: String!) {
            expertise(id: $skillsetId) {
                rating {
                    topNodeIds, topNodeNames, distribution,
                    ratings {
                        userId, userName, totalScore, topNodeScore
                    }
                }
          }
        }`;
        return await Api.postData('/g', { query: query, variables: { skillsetId: skillsetId }  });
    }

    static async loadChildSubjects(subjectId) {
        let query = `query ($subjectId: String!) {
            subject(id: $subjectId) {
                id, 
                childSubjects {
                    id, name, imageUrl
                }                
          }
        }`;
        return await Api.postData('/g', { query: query, variables: { subjectId: subjectId }  });
    }
    
    static async searchSubjectsByName(text) {
        let query = `query ($text: String!) {
            searchSubjectsByName(text: $text) {
                id, name, imageUrl,
                primarySubjects {
                    id, name
                }                
          }
        }`;
        const response = await Api.postData('/g', { query: query, variables: { text: text }  });
        return response.data.searchSubjectsByName;
    }
    
    static async saveNodeParams(graphId, skillId, params) {
        let result = await Api.postData('/api/saveNodeParams', { graphId: graphId, skillId: skillId, params: params });
        return result;
    }

    static async getMaterialInfo(url) {
        if (url.length < "https://x.y".length)
            return { ok: true };
        let result = await Api.postData('/api/getMaterialInfo', { url: url });
        return result;
    }

    static async create(obj) {
        let result = await Api.postData('/api/create', obj);
        return result;
    }
    static async createSubject(subjectId, newSubject) {
        let result = await Api.postData('/api/createSubject', { subjectId: subjectId, newSubject: newSubject });
        return result;
    }

    static async createSkill(skill, subjectId) {
        return await Api.postData('/api/createSkill', {id: skill.id, name: skill.name, description: skill.description, subjectId: subjectId, area: skill.area});
    }

    static async createAchievement(skill, subjectId) {
        return await Api.postData('/api/createAchievement', {id: skill.id, name: skill.name, description: skill.description, subjectId: subjectId, area: skill.area, image: skill.image, type: skill.type});
    }

    static async createNode(node) {
        return await Api.postData('/api/createNode', node);
    }

    static async addSubject(subjectId, newSubject, skillId, graphId) {
        let result = await Api.postData('/api/addSubject', { subjectId: subjectId, newSubject: newSubject, skillId: skillId, graphId: graphId});
        return result;
    }

    static async removeSubject(subjectId, skillId, graphId) {
        let result = await Api.postData('/api/removeSubject', { subjectId: subjectId, skillId: skillId, graphId: graphId });
        return result;
    }

    static async removeSkillMaterial(skillId, materialId) {
        let result = await Api.postData('/api/removeSkillMaterial', { skillId: skillId, materialId: materialId });
        return result;
    }

    static async removeSkillQuestion(skillId, questionId) {
        let result = await Api.postData('/api/removeSkillQuestion', { skillId: skillId, questionId: questionId });
        return result;
    }

    static async removeSkillKnowledge(skillId, knowledgeId) {
        let result = await Api.postData('/api/removeSkillKnowledge', { skillId: skillId, knowledgeId: knowledgeId });
        return result;
    }

    static async removeSkillMaterial(skillId, materialId) {
        let result = await Api.postData('/api/removeSkillMaterial', { skillId: skillId, materialId: materialId });
        return result;
    }

    static async removeSkillExpertise(skillId, expertiseId) {
        let result = await Api.postData('/api/removeSkillExpertise', { skillId: skillId, expertiseId: expertiseId });
        return result;
    }

    static async addLink(sourceId, targetId, graphId, index) {
        let result = await Api.postData('/api/addLink', { subjectId: sourceId, skillId: targetId, graphId: graphId, index: index });
        return result;
    }
    
    static async getDraftChanges(graphId, draftId) {
        let result = await Api.postData('/api/getDraftChanges', { graphId: graphId, draftId: draftId });
        return result;
    }
    
    static async changeSubject(nodeId, subjectId) {
        let result = await Api.postData('/api/changeSubject', { nodeId: nodeId, subjectId: subjectId });
        return result;
    }

    static async exportCourse(skillId, url) {
        let result = await Api.postData('/api/exportCourse', { skillId: skillId, url: url });
        return result;
    }

    static async authFacebook(auth_token) {
        console.log('auth in facebook', auth_token);
        let result = await Api.postData('/api/authenticate_facebook', { data: auth_token });
        return result;
    }    

    static async authGoogle(auth_token) {
        console.log('auth in google', auth_token);
        let result = await Api.postData('/api/authenticate_google', { data: auth_token });
        return result;
    }    

    static async authVk(auth_token) {
        console.log('auth in vk', auth_token);
        let result = await Api.postData('/api/authenticate_vk', { data: auth_token });
        return result;
    }

    static async auth(email, password) {
        console.log('auth as', email);
        let result = await Api.postData('/api/auth/login', { email: email, password: password });
        return result;
    }    

    static async logout() {
        let result = await Api.postData('/api/logout');
        return result;
    }

    static async like(id) {
        let result = await Api.postData('/api/like', { targetId: id });
        return result;
    }

    static async unlike(id) {
        let result = await Api.postData('/api/unlike', { targetId: id });
        return result;
    }

    static async checkSlug(skillId, slug) {
        let result = await Api.postData('/api/checkSlug', { skillId: skillId, slug: slug });
        return result;
    }

    static async execute(text) {
        const response = await fetch('/api/console', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(text) });
        return await response.text();
    }

    static async searchSkills(text, type) {
        if (!text)
            return [];
        const response = await fetch('/api/search?q=' + encodeURIComponent(text) + '&type=' + type);
        if (response.ok) {
            const skills = await response.json();
            console.log('search results', skills);
            return skills;
        } else {
            console.error("Skill search failed", response);
        }
        return [];
    }

    static async searchSkillsV2(text) {
        if (!text)
            return [];
        let query = `query ($text: String!) {
          searchSkills (text: $text) {
            id, name, primarySubject { name }, area
          }
        }`;
        let result = await Api.postData('/g', { query: query, variables: { text: text } });
        return result.data.searchSkills;
    }

    static async searchAchievements(text) {
        if (!text)
            return [];
        let query = `query ($text: String!) {
          searchAchievements (text: $text) {
            id, name, primarySubject { name }, area
          }
        }`;
        let result = await Api.postData('/g', { query: query, variables: { text: text } });
        return result.data.searchAchievements;
    }

    static async searchStructures(text) {
        if (!text)
            return [];
        let query = `query ($text: String!) {
            searchStructures (text: $text) {
            id, name, primarySubject { name }, area, thumbnail
          }
        }`;
        let result = await Api.postData('/g', { query: query, variables: { text: text } });
        return result.data.searchStructures;
    }
    
    static async saveLinksParams(links) {
        let raw = links.map(l => {
            let obj = {
                id: l.id,
                data: JSON.stringify(l.params)
            };
            return obj;
        });
        let result = await Api.postData('/api/updateLinksData', raw);
        return result;
    }

    static async stat() {
        let data = {
            agent: navigator.userAgent,
            width: screen.availWidth,
            height: screen.availHeight,
        };
        try {
            const response = await fetch("/api/stat", {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({data: JSON.stringify(data)})
            });
            await response.text();            
        } catch (ignored) {}
    }

    static getUntrustedUrl() {
        if (window.origin.indexOf("//staging.infinite.education") >= 0) {
            return window.origin.replace("//", "//untrusted")
        } else {
            return window.origin.replace("//", "//untrusted.");
        }
    }
}
